import { useContentSubpageInstance } from "@plugins/content-subpage/composables/content-subpage-instance.ts";
import ProfileContentSubpage from "@modules/profile/components/ProfileContentSubpage.vue";

export interface HandleProfileClickOptions {
  userId: number;
  isDisabled?: boolean;
}

export function useSearchProfile() {
  const contentSubpage = useContentSubpageInstance();

  const handleProfileClick = ({ userId, isDisabled }: HandleProfileClickOptions) => {
    if (isDisabled || userId === 0) {
      return;
    }
    contentSubpage.show(ProfileContentSubpage, { userId });
  };

  return {
    handleProfileClick,
  };
}
